<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">
      {{ viewMode === ViewMode.Create ? "Create explicit folder permission" : viewMode === ViewMode.View ? "View explicit folder permission" : "Edit explicit folder permission" }}
    </div>
    <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }

    <coso-select-input type="text" [control]="formGroup.controls.filterType" [inputText]="formText.filterType" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    @if (formGroup.controls.filterType.value == FilterType.Entity) {
    <coso-select-input type="text" [control]="formGroup.controls.filterValue" [inputText]="formText.filterValue" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    } @if (formGroup.controls.filterType.value == FilterType.SharePointFolder) {
    <coso-text-input type="text" [control]="formGroup.controls.filterValue" [inputText]="formText.filterValue" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    }
    <coso-select-input type="text" [control]="formGroup.controls.principalType" [inputText]="formText.principalType" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    <coso-select-input type="text" [control]="formGroup.controls.principalValue" [inputText]="formText.principalValue" [readonly]="viewMode === ViewMode.View"></coso-select-input>
    <coso-select-input type="text" [control]="formGroup.controls.privilegeLevelID" [inputText]="formText.privilegeLevelID" [readonly]="viewMode === ViewMode.View"></coso-select-input>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
    <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>

<ng-template #filterTypePopover>
  <p>The type of the filter to be applied.</p>
  <p><strong>Global:</strong> The filter will be applied to all SharePoint document locations.</p>
  <p><strong>Entity:</strong> The filter will be applied to all SharePoint document locations based on the <strong>Filter Value</strong> field.</p>
  <p><strong>SharePoint Folder:</strong> The filter will be applied only to the SharePoint folder defined on the <strong>Filter Value</strong> field.</p>
</ng-template>

<ng-template #filterValuePopover>
  @switch (formGroup.controls.filterType.value) { @case (FilterType.Entity) {
  <span>The logical name of a Dynamics 365 entity.</span>
  } @case (FilterType.SharePointFolder) {
  <div>
    <p>The absolute or relative path of the folder in SharePoint (referenced from Dynamics 365).</p>
    Examples:
    <ul>
      <li>/account/Connecting Software_46C51FDA6844EB11A8120022481675E6</li>
      <li>https://crm799321.sharepoint.com/sites/replicator/account/Connecting Software_46C51FDA6844EB11A8120022481675E6</li>
    </ul>
  </div>
  } }
</ng-template>

<ng-template #principalTypePopover>
  <p>The type of a principal.</p>
  @if (groupStorage === GroupStorage.SharePoint) {
  <p><strong>SharePoint User:</strong> The permission for a specific SharePoint user will be added to the calculated permissions.</p>
  <p><strong>SharePoint Group:</strong> The permission for a specific SharePoint group will be added to the calculated permissions.</p>
  }
  <p><strong>Directory Group:</strong> The permission for a specific Directory group will be added to the calculated permissions.</p>
  <p><strong>Dynamics 365 User:</strong> The permission for a SharePoint user that is mapped to a Dynamics 365 user will be added to calculated permissions.</p>
  <p><strong>Dynamics 365 Team:</strong> The permission for a SharePoint group that is replica of a D365 team will be added to calculated permissions.</p>
</ng-template>

<ng-template #principalValuePopover>
  @switch (formGroup.controls.principalType.value) { @case (PrincipalType.SharePointUser) {
  <span>The ID of a SharePoint user.</span>
  } @case (PrincipalType.SharePointGroup) {
  <span>The ID of a SharePoint group.</span>
  } @case (PrincipalType.DirectoryGroup) {
  <span>The name of a directory group.</span>
  } @case (PrincipalType.CRMUser) {
  <span>The ID of a Dynamics 365 user (<i>systemuser</i> entity).</span>
  } @case (PrincipalType.CRMTeam) {
  <span>The ID of a Dynamics 365 team (<i>team</i> entity).</span>
  } }
</ng-template>
